import {Pipe, PipeTransform} from '@angular/core';
import getImageUrl from "../functions/getImageUrl";

@Pipe({
  name: 'imageUrl',
  standalone: true
})
export class ImageUrlPipe implements PipeTransform {

  transform(value: any): unknown {
    if (value) {
      return getImageUrl(Array.isArray(value) ? value[0] : value);
    }
    return '/assets/img/nav/LOGO.svg';
  }
}
